"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deepEqualDependencies = void 0;

var _dependenciesEqualGenerated = require("./dependenciesEqual.generated.js");

var _dependenciesTypedGenerated = require("./dependenciesTyped.generated.js");

var _factoriesAny = require("../../factoriesAny.js");

/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
var deepEqualDependencies = {
  equalDependencies: _dependenciesEqualGenerated.equalDependencies,
  typedDependencies: _dependenciesTypedGenerated.typedDependencies,
  createDeepEqual: _factoriesAny.createDeepEqual
};
exports.deepEqualDependencies = deepEqualDependencies;